export const TAXES_CONSTANTS = {
    toggles: {
        dclInternationalDirect: 'dclInternationalDirect'
    },
    sailingsContentKey: 'taxes-fees-expenses.gst-excluded-sailings'
};
